module.exports = __webpack_public_path__ + "img/facebook.44f7f590.svg";